export default "/images/claritick-icon-2.svg?4da92088b4ad3fa635dce03bbd72b07f";